<template>
  <div id="app">
    <header-element></header-element>
    <story-element></story-element>
    <opensource-element></opensource-element>
    <footer-element></footer-element>
  </div>
</template>

<script>
import HeaderElement from "@/components/header.vue";
import FooterElement from "@/components/footer.vue";
import StoryElement from "@/components/story.vue";
import OpensourceElement from "@/components/opensource.vue";

export default {
  name: "app",
  components: {
    HeaderElement,
    FooterElement,
    StoryElement,
    OpensourceElement
  }
};
</script>
